import { SearchPageChrome } from "@/components/search/page-chrome"

import { SaveButton } from "@/components/shared/action-buttons"
import { Card, CardContent } from "@/components/ui/card"
import { PageBody } from "@/components/ui/layout"
import { useId } from "react"
import { FormRenderer } from "@/lib/data-driven-forms/renderer"
import { DataDrivenFormSchema } from "@/lib/data-driven-forms/schema"
import * as z from "zod"
import { VALIDATION_ERROR_KEYS } from "@/i18n"
import { useNavigate } from "@/lib/page-rendering"

const formSchema: DataDrivenFormSchema<"shortlists"> = {
  type: "form",
  validator: z.object({
    name: z.string().trim().min(1, VALIDATION_ERROR_KEYS.REQUIRED),
  }),
  namespace: "shortlists",
  properties: [
    {
      type: "field:input",
      name: "name",
      label: "form.name.label",
      inputType: "text",
    },
  ],
}

export default function Page() {
  const navigate = useNavigate()
  const id = useId()

  return (
    <>
      <SearchPageChrome action={<SaveButton form={id} />} />
      <PageBody>
        <Card>
          <CardContent className="p-6">
            <FormRenderer
              schema={formSchema}
              defaultValues={{}}
              onSubmit={(data) =>
                navigate({
                  href: "/search/shortlists",
                  method: "post",
                  data: {
                    shortlist: { name: data.name },
                  },
                })
              }
              formId={id}
              registerDirtyDraft
            />
          </CardContent>
        </Card>
      </PageBody>
    </>
  )
}
